/*
 *  全局定义信息
 *
 *  @author terrfly
 *  @site https://www.jeepay.vip
 *  @date 2021/5/8 07:18
 */

const errorPageRouteName = 'Error' //错误页面名称定义
const passGuardRouteList = [errorPageRouteName]  // 不进入路由守卫的name

/** 定义支付方式 **/
const payWay = {
    WXPAY : {wayCode: "WX_JSAPI", routeName: "CashierWxpay"},
    ALIPAY : {wayCode: "ALI_JSAPI", routeName: "CashierAlipay"},
    ALIPAY_QR : {wayCode: "ALI_QR", routeName: "CashierAlipay"},
    ALIPAY_OC : {wayCode: "ALI_OC", routeName: "CashierAlipay"},
    WXPAY_H5 : {wayCode: "WX_H5", routeName: "WebCashier"},
    WXPAY_NATIVE : {wayCode: "WX_NATIVE", routeName: "WebCashier"},
    ALIPAY_WAP : {wayCode: "ALI_WAP", routeName: "WebCashier"},
    ALIPAY_PC : {wayCode: "ALI_PC", routeName: "WebCashier"},
    EXCLUSIVE : {wayCode: "EXCLUSIVE_QR", routeName: "WebCashier"}
}

export default {
    errorPageRouteName: errorPageRouteName,
    passGuardRouteList: passGuardRouteList,
    urlTokenName: "jeepayToken", //URL传递的token名称
    payWay: payWay,
    cacheToken: ""
}
